import { Component, type ReactNode } from 'react'
import { ErrorPage } from '@carouselgg/nexus/status-page'
import { ShellFallback } from '@carouselgg/auth/remote-chrome'

interface Props {
  children: ReactNode
  name: string
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      // A remote that failed to load can't draw its own nav — bring the shell back.
      return (
        <>
          <ShellFallback />
          <ErrorPage
            message={`Something went wrong loading ${this.props.name}. Give it another shot.`}
            onRetry={() => this.setState({ hasError: false })}
          />
        </>
      )
    }

    return this.props.children
  }
}
